import { render, staticRenderFns } from "./buyYx.vue?vue&type=template&id=52f76a03&"
import script from "./buyYx.vue?vue&type=script&lang=js&"
export * from "./buyYx.vue?vue&type=script&lang=js&"
import style0 from "./buyYx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports